import React from 'react';
import Grid, { GridProps } from '@material-ui/core/Grid';
import { VseApplFormDocumentUpload, VseApplFormDocumentEventHandler } from './VseApplFormDocumentUpload';
import { VseApplFormDocumentUploadHandle } from '../types/VseApplFormDocumentUploadHandle';
import {
  DotNetValidationProblemDetailsTyped,
  VseApplicationEntity,
  VseApplFormDocumentUploadConfig,
} from '../types';

export interface VseApplFormDocumentChangeEvent {
  event: React.ChangeEvent<HTMLInputElement>,
  config: VseApplFormDocumentUploadConfig,
}

export type VseApplFormDocumentChangeEventHandler = (event: VseApplFormDocumentChangeEvent) => void;

export interface VseApplFormDocumentCancelEvent {
  event: React.MouseEvent<HTMLButtonElement>,
  config: VseApplFormDocumentUploadConfig,
}

export type VseApplFormDocumentCancelEventHandler = (event: VseApplFormDocumentCancelEvent) => void;

export interface VseApplFormDocumentSelectionProps extends GridProps {
  handles: Array<VseApplFormDocumentUploadHandle>,
  onDocumentUpload: VseApplFormDocumentEventHandler,
  onDocumentCancel: VseApplFormDocumentEventHandler,
  onValidationProblem: (valProblems: DotNetValidationProblemDetailsTyped<VseApplicationEntity>) => void,
}

export function VseApplFormDocumentSelection(props: VseApplFormDocumentSelectionProps) {

  const uploads = props.handles.map((handle, index) => {
    return (
      <Grid
        key={index}
        item xs={12} md={4}>
        <VseApplFormDocumentUpload
          requestId={handle.requestId}
          fileID={handle.fileID}
          documentType={handle.config.documentType}
          title={handle.config.title}
          required={handle.config.required}
          accept={handle.config.accept}
          uploading={handle.uploading}
          uploaded={handle.uploaded}
          onDocumentCancel={props.onDocumentCancel}
          onDocumentUpload={props.onDocumentUpload}
          onValidationProblem={props.onValidationProblem}
        />
      </Grid>
    );
  });
  return (
    <Grid className={props.className} container>
      {uploads}
    </Grid>
  );
}
